'use memo';

import { useEffect } from 'react';

import { useGlobalAiChatStore } from '@/features/global-ai-chat/store/globalAiChatStore';

/**
 * グローバルショートカットで AI チャットを開閉する。
 * Cmd+J (Mac) / Ctrl+J (Win/Linux) — Notion の AI 起動と同じキーバインド。
 */
export function useToggleAiChatByKeyPress(): void {
  const toggleOpen = useGlobalAiChatStore((state) => state.toggleOpen);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // 長押し時の連続発火（repeat）は無視し、開閉が高速トグルし続けるのを防ぐ。
      if (event.repeat) return;
      // 素の Cmd/Ctrl+J のみ。alt/shift 付き（Cmd+Option+J / Ctrl+Shift+J = DevTools 起動）は
      // ブラウザ既定を奪わないよう除外する。
      if (
        (event.metaKey || event.ctrlKey) &&
        !event.altKey &&
        !event.shiftKey &&
        event.key.toLowerCase() === 'j'
      ) {
        // Cmd+J はブラウザ既定（Chrome: ダウンロード表示）を持つため抑止する
        event.preventDefault();
        toggleOpen();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggleOpen]);
}
